import { j as e } from "../../../../jsx-runtime-CQ7OqOhn.js";
import { rightIconOptions as u } from "../TextField.consts.js";
import o from "../../../../utilities/tw.js";
import x from "../../Icon/Icon.js";
import h from "../../Button/Button.js";
import g from "../../Button/IconButton/IconButton.js";
import a from "../../../../tailwindConfig/bclTwMerge.js";
const z = ({
  id: i,
  type: p,
  content: n,
  className: s = "",
  onClick: t,
  iconLabel: m = ""
}) => {
  const c = a(
    o`pointer-events-none size-auto py-0 leading-[0] text-neutral-inverse`,
    t && o`pointer-events-auto cursor-pointer`,
    s
  ), f = a(
    o`pointer-events-none h-fit py-0 text-sm/1 font-medium capitalize text-primary`,
    t && o`pointer-events-auto cursor-pointer hover:text-primary-hover`,
    s
  );
  return p === "icon" ? /* @__PURE__ */ e.jsx(
    g,
    {
      variant: "ghost",
      className: c,
      iconName: m,
      onClick: (r) => {
        t && (r.stopPropagation(), t());
      },
      children: /* @__PURE__ */ e.jsx(
        x,
        {
          icon: u[n],
          "data-testid": `${i}-right-cta-icon`
        }
      )
    }
  ) : /* @__PURE__ */ e.jsx(
    h,
    {
      variant: "ghost",
      className: f,
      onClick: (r) => {
        t && (r.stopPropagation(), t());
      },
      "data-testid": `${i}-right-cta-text`,
      children: n
    }
  );
};
export {
  z as default
};
